import { useMemo } from "react";
import {
  InternalAdminUserAttributeQuery,
  InternalAdminUserAttributeQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_USER_ATTRIBUTE_QUERY from "../_networking/internal-admin-user-attribute";

const useInternalAdminUserAttributes = (id: string | string[] | undefined) => {
  const isValid = (Array.isArray(id) && id.length > 0) || !!id;

  const { data, loading } = useQuery<
    InternalAdminUserAttributeQuery,
    InternalAdminUserAttributeQueryVariables
  >(INTERNAL_ADMIN_USER_ATTRIBUTE_QUERY, {
    fetchPolicy: "network-only",
    variables: id
      ? {
          id,
        }
      : undefined,
    skip: !isValid,
  });

  const userAttributes = useMemo(() => {
    if (!data) return [];
    return data.internalAdminUserAttribute;
  }, [data]);

  const userAttribute = useMemo(() => {
    if (userAttributes && userAttributes.length === 1) {
      return userAttributes[0];
    }
    return undefined;
  }, [userAttributes]);

  return {
    userAttribute,
    userAttributes,
    loading,
  };
};

export default useInternalAdminUserAttributes;
